import React from 'react';
import MatrixAnimation from '../Effects/MatrixAnimation';



const Inicio = () => {
    return (
        <section id='inicio' className='min-vh-100 d-flex align-items-center text-center mb-5'>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className="col-10 col-md-6 text-white">
                        <h1 className='display-3 fw-light d-none d-sm-block mt-5'>Landing pages, Ecommerce y Sistemas a medida</h1>
                        <h1 className='fw-light d-sm-none fs-1'>Landing pages, Ecommerce y Sistemas a medida</h1>
                        <p className='lead mt-3'>Soluciones digitales que potencian tu negocio en Paraguay y la región.</p>
                        <div>
                            <a href="#nosotros" className='btn btn-neon mt-4'>Más Info</a>
                        </div>
                    </div>
                </div>
            </div>
            <MatrixAnimation />
        </section>

    )
}

export default Inicio